import { ethers } from 'ethers';
import { ethereum } from '@cosmostation/extension-client';

import { WALLET_TYPE } from 'src/constants/wallets';
import type { WalletType } from 'src/types/wallet';

export function isWalletInstalled(walletType: WalletType) {
  if (walletType === WALLET_TYPE.METAMASK) {
    return window.ethereum?.isMetaMask || false;
  }
  if (walletType === WALLET_TYPE.COSMOSTATION) {
    return 'cosmostation' in window;
  }
  return false;
}

export function isWalletConnected(walletType: WalletType) {
  try {
    if (walletType === WALLET_TYPE.METAMASK) {
      return window.ethereum?.isConnected() || false;
    }
    if (walletType === WALLET_TYPE.COSMOSTATION) {
      return true;
    }
  } catch (e) {
    return false;
  }
  return false;
}

export async function connectWallet(walletType: WalletType) {
  if (typeof window.ethereum !== 'undefined' && walletType === 'Metamask' && isWalletInstalled(walletType)) {
    const ethProvider = new ethers.BrowserProvider(window.ethereum);

    const response = (await ethProvider.send('eth_requestAccounts', [])) as string[];

    const responseChainId = (await ethProvider.send('eth_chainId', [])) as string;

    return { response, responseChainId };
  }

  if (walletType === 'Cosmostation' && isWalletInstalled(walletType)) {
    const cosmostationProvider = await ethereum();

    const ethProvider = new ethers.BrowserProvider(cosmostationProvider);

    const response = (await ethProvider.send('eth_requestAccounts', [])) as string[];

    const responseChainId = (await ethProvider.send('eth_chainId', [])) as string;
    return { response, responseChainId };
  }
  return { response: [], responseChainId: '' };
}
